import Vue from 'vue'
import moment from 'moment'

let util = {
  data: {
    loader: false
  },

  getFormatedPrice (value) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(value)
  },

  getDate (val) {
    if (!val) return
    return moment(val).format('DD.MM.Y')
  },

  startLoader () {
    if (!this.data.loader) { this.data.loader = Vue.$loading.show() }
  },

  stopLoader () {
    this.data.loader.hide()
    this.data.loader = false
  },

  randomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min);
  },

  buildURLQuery(obj){
      let url = Object.entries(obj)
                .map(pair => pair.map(encodeURIComponent).join('='))
                .join('&');

      return url
  },

  isError(name){
      return this.getError(name).length == 0 ? false: true
  },

  getError(name){
      return this.form.errors.has(name) ? this.form.errors.errors[name][0] : ''
  },


}

Vue.prototype.$util = util

export default util
